import "./breadcrumbs.component.css";

export interface Step {
  stepNumber: number;
  label: string;
  labelNumber: number;
  initialValues: any;
  validationSchema: any;
}
interface CustomBreadcrumbProps {
  steps: Step[];
  currentStep: number;
}

interface StepCircle {
  stepNumber: number;
  label: string;
  labelNumbers: number[];
}

const CustomBreadcrumb = ({ steps, currentStep }: CustomBreadcrumbProps) => {
  const uniqueStepsMap = new Map<number, StepCircle>();

  steps.forEach(({ labelNumber, label, stepNumber }) => {
    if (!uniqueStepsMap.has(labelNumber)) {
      uniqueStepsMap.set(labelNumber, { stepNumber: labelNumber, label, labelNumbers: [stepNumber] });
    } else {
      const u = uniqueStepsMap.get(labelNumber)!;
      uniqueStepsMap.set(labelNumber, { ...u, labelNumbers: [...u?.labelNumbers, stepNumber] });
    }
  });

  const uniqueStepsArray = Array.from(uniqueStepsMap.values());

  return (
    <div className="row step-indicator">
      {uniqueStepsArray.map((step, index) => (
        <div className="col-12 col-md-4 col-lg-2" key={index}>
          <p className="step-label">
            <span
              className={`step-circle ${
                step.labelNumbers.includes(currentStep) ? "active" : currentStep > step.stepNumber ? "" : ""
              }`}
            >
              {step.stepNumber}
            </span>
            <span dangerouslySetInnerHTML={{ __html: step.label }} />
          </p>
        </div>
      ))}
    </div>
  );
};

export default CustomBreadcrumb;
